import { Directive, HostListener } from '@angular/core';
import { AccountsContextService } from '../../../../accounts/account-context.service';
import { take } from 'rxjs/operators';

@Directive({ selector: '[appLogoClick]' })
export class LogoClickDirective {
  constructor(
    public contextService: AccountsContextService,
  ) { }

  @HostListener('click')
  public onClickLogo(): void {
    const copyCurrentRoute = this.contextService.currentRoute;
    this.contextService.homeRedirectRoute$
      .pipe(take(1))
      .subscribe(
        homeUrl => {
          if (homeUrl === copyCurrentRoute) {
            location.reload();
          }
        }
      );
  }
}
